import React, { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Render with hover highlight effect */
  hoverable?: boolean;
  /** Active / selected state */
  active?: boolean;
  /** Card padding preset */
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}

const padStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ hoverable, active, padding = 'md', className = '', children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={[
          'bg-[var(--sage-surface)] rounded-xl border transition-colors',
          active
            ? 'border-[var(--sage-primary)] bg-[var(--sage-surface-hover)]'
            : 'border-[var(--sage-white-5)]',
          hoverable && !active ? 'hover:border-[var(--sage-white-10)] hover:bg-[var(--sage-surface-hover)] cursor-pointer' : '',
          padStyles[padding],
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';
